import { enumUtil } from '@/utils';

const StatusEnumerator = {
  Apagado: new enumUtil.EnumBase(-1, 'Apagado'),
  Ativo: new enumUtil.EnumBase(0, 'Ativo'),
  Sincronizado: new enumUtil.EnumBase(1, 'Sincronizado'),
  AlteradoServidor: new enumUtil.EnumBase(2, 'AlteradoServidor'),
};

const TipoDataEnumerator = Object.freeze({
  Data: new enumUtil.EnumBase(1, 'Data'),
  DataHora: new enumUtil.EnumBase(2, 'Data e hora'),
  DataHoraEfetivado: new enumUtil.EnumBase(3, 'Data e hora efetivado'),
});

const TakePaginationEnumerator = Object.freeze({
  10: new enumUtil.EnumBase(10, '10'),
  25: new enumUtil.EnumBase(25, '25'),
  50: new enumUtil.EnumBase(50, '50'),
  75: new enumUtil.EnumBase(75, '75'),
  100: new enumUtil.EnumBase(100, '100'),
});

const UfsEnumerator = Object.freeze({
  AC: new enumUtil.EnumBase('AC', 'AC'),
  AL: new enumUtil.EnumBase('AL', 'AL'),
  AM: new enumUtil.EnumBase('AM', 'AM'),
  AP: new enumUtil.EnumBase('AP', 'AP'),
  BA: new enumUtil.EnumBase('BA', 'BA'),
  CE: new enumUtil.EnumBase('CE', 'CE'),
  DF: new enumUtil.EnumBase('DF', 'DF'),
  ES: new enumUtil.EnumBase('ES', 'ES'),
  GO: new enumUtil.EnumBase('GO', 'GO'),
  MA: new enumUtil.EnumBase('MA', 'MA'),
  MG: new enumUtil.EnumBase('MG', 'MG'),
  MS: new enumUtil.EnumBase('MS', 'MS'),
  MT: new enumUtil.EnumBase('MT', 'MT'),
  PA: new enumUtil.EnumBase('PA', 'PA'),
  PB: new enumUtil.EnumBase('PB', 'PB'),
  PE: new enumUtil.EnumBase('PE', 'PE'),
  PI: new enumUtil.EnumBase('PI', 'PI'),
  PR: new enumUtil.EnumBase('PR', 'PR'),
  RJ: new enumUtil.EnumBase('RJ', 'RJ'),
  RN: new enumUtil.EnumBase('RN', 'RN'),
  RO: new enumUtil.EnumBase('RO', 'RO'),
  RR: new enumUtil.EnumBase('RR', 'RR'),
  RS: new enumUtil.EnumBase('RS', 'RS'),
  SC: new enumUtil.EnumBase('SC', 'SC'),
  SE: new enumUtil.EnumBase('SE', 'SE'),
  SP: new enumUtil.EnumBase('SP', 'SP'),
  TO: new enumUtil.EnumBase('TO', 'TO'),
  EX: new enumUtil.EnumBase('EX', 'EX'),
});

const UfEnumeratorWithCodigoUf = Object.freeze({
  None: new enumUtil.EnumBase(0, ''),
  AC: new enumUtil.EnumBase(12, 'AC'),
  AL: new enumUtil.EnumBase(27, 'AL'),
  AM: new enumUtil.EnumBase(13, 'AM'),
  AP: new enumUtil.EnumBase(16, 'AP'),
  BA: new enumUtil.EnumBase(29, 'BA'),
  CE: new enumUtil.EnumBase(23, 'CE'),
  DF: new enumUtil.EnumBase(53, 'DF'),
  ES: new enumUtil.EnumBase(32, 'ES'),
  GO: new enumUtil.EnumBase(52, 'GO'),
  MA: new enumUtil.EnumBase(21, 'MA'),
  MG: new enumUtil.EnumBase(31, 'MG'),
  MS: new enumUtil.EnumBase(50, 'MS'),
  MT: new enumUtil.EnumBase(51, 'MT'),
  PA: new enumUtil.EnumBase(15, 'PA'),
  PB: new enumUtil.EnumBase(25, 'PB'),
  PE: new enumUtil.EnumBase(26, 'PE'),
  PI: new enumUtil.EnumBase(22, 'PI'),
  PR: new enumUtil.EnumBase(41, 'PR'),
  RJ: new enumUtil.EnumBase(33, 'RJ'),
  RN: new enumUtil.EnumBase(24, 'RN'),
  RO: new enumUtil.EnumBase(11, 'RO'),
  RR: new enumUtil.EnumBase(14, 'RR'),
  RS: new enumUtil.EnumBase(43, 'RS'),
  SC: new enumUtil.EnumBase(42, 'SC'),
  SE: new enumUtil.EnumBase(28, 'SE'),
  SP: new enumUtil.EnumBase(35, 'SP'),
  TO: new enumUtil.EnumBase(17, 'TO'),
  EX: new enumUtil.EnumBase(99, 'EX'),
});

const TipoArredondamentoEnumerator = Object.freeze({
  Padrao: new enumUtil.EnumBase(0, 'Padrão'),
  ParaCima: new enumUtil.EnumBase(1, 'Arredondar para cima'),
  ParaBaixoOuTruncar: new enumUtil.EnumBase(2, 'Arredondar para baixo'),
  Abnt: new enumUtil.EnumBase(4, 'Regra ABNT'),
});

const DiaSemanaEnumerator = Object.freeze({
  Domingo: new enumUtil.EnumBase(1, 'dom'),
  SegundaFeira: new enumUtil.EnumBase(2, 'seg'),
  TercaFeira: new enumUtil.EnumBase(3, 'ter'),
  QuartaFeira: new enumUtil.EnumBase(4, 'qua'),
  QuintaFeira: new enumUtil.EnumBase(5, 'qui'),
  SextaFeira: new enumUtil.EnumBase(6, 'sex'),
  Sabado: new enumUtil.EnumBase(7, 'sab'),
});

const CnpjCpfEnumerator = Object.freeze({
  Cnpj: new enumUtil.EnumBase(1, 'Cnpj'),
  Cpf: new enumUtil.EnumBase(2, 'Cpf'),
});

export { StatusEnumerator, TipoDataEnumerator, TakePaginationEnumerator, UfsEnumerator, UfEnumeratorWithCodigoUf, TipoArredondamentoEnumerator, DiaSemanaEnumerator, CnpjCpfEnumerator };
